import { Sheet, SheetContent, SheetTrigger } from "@/components/ui/sheet";
import React from "react";
import SvgClose from "../../../assets/icons/SvgClose";
import SvgSearch from "../../../assets/icons/SvgSearch";
import algoliasearch from 'algoliasearch/lite';
import { InstantSearch } from 'react-instantsearch';
import SearchBox from "./SearchBox";
import SearchResults from "./SearchResults";

const searchClient = algoliasearch(
    process.env.GATSBY_ALGOLIA_APP_ID,
    process.env.GATSBY_ALGOLIA_SEARCH_KEY
);

let timerId = undefined;
let timeout = 800;

function debounceSearchInput(query, search) {
  if (timerId) {
    clearTimeout(timerId);
  }

  timerId = setTimeout(() => search(query), timeout);
}

export default function Search() {

  return (
    <InstantSearch searchClient={searchClient} insights={{ useCookie: true }}>
      <Sheet>
        <SheetTrigger
            asChild
            className="group-hover:hover:text-secondary-500 group-hover:text-[#111] cursor-pointer flex items-center text-[#111]"
            role="button"
            title="Search"
        >
          <SvgSearch style={{width: "20px", height: "20px"}}/>
        </SheetTrigger>
        <SheetContent
            side="top"
            noOverlay
            className="bg-primary-500 border-b-0 overflow-y-auto"
        >
          <div className="flex flex-col mt-[50px] overflow-y-auto overflow-x-hidden lg:mx-5 grow">
            <SheetTrigger
                asChild
                className="absolute text-white text-[10px] top-[50px] right-[50px] hover:text-secondary-500 cursor-pointer"
                role="button"
            >
              <SvgClose/>
            </SheetTrigger>
            <SearchBox
              queryHook={debounceSearchInput}
            />
            <SearchResults />
          </div>
        </SheetContent>
      </Sheet>
    </InstantSearch>
  );
}
